import React, { useState, useEffect, useRef} from 'react';
import Cookies from 'js-cookie';
import AsyncSelect from "react-select/async";
import {
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Button,
    Box,
    Typography,
    Snackbar,
    RadioGroup,
    FormControlLabel,
    Radio,
    Paper,
    Alert
} from '@mui/material';
import Slide from '@mui/material/Slide';

import { usePlacesWidget } from 'react-google-autocomplete';
import { data, useNavigate } from 'react-router-dom';
import { fetchWithAuth } from './lib/utils';
import './styles/IncidentDetail.css'; // Import the CSS file for the form
import './styles/ReportIncidentForm.css'; // Import the CSS file for the form
import { FaBook, FaCog, FaBars, FaTimes, FaPen,FaSearch } from 'react-icons/fa'; // Import the book, plus, bars, and times icons
import { useIsMobile } from './hooks/isMobile';
import {jwtDecode} from "jwt-decode"




const ReportIncidentForm = ({ setModalIsOpen, onIncidentSubmit }) => {
    const navigate = useNavigate(); // Initialize the useNavigate hook

    const [race, setRace] = useState('');
    const [incident_type, setIncidentType] = useState('');
    const [additional_info, setAdditionalInfo] = useState('');
    const [description, setDescription] = useState('');
    const [date_time, setIncidentDateTime] = useState(new Date().toISOString().slice(0, 16)); // Set default to now
    const [sexual_orientation, setSexualOrientation] = useState('');
    const [gender, setGender] = useState('');
    const [place_id, setPlaceId] = useState('');
    const [placeDetailsMap, setPlaceDetailsMap] = useState(new Map());
    const [place_name, setPlaceName] = useState('');
    const[photoBlob, setPhotoBlob] = useState(null);
    const [file, setFile] = useState(null);
    const placeIdRef = useRef('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [submissionType, setSubmissionType] = useState('self');
    const[myIncident, setMyIncident] = useState(true);
    const [disability_type, setDisabilityType] = useState("");
    const [disability, setDisability] = useState("");
    

    
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const isMobile = useIsMobile(); // Use the useIsMobile hook
    const [isNavOpen, setIsNavOpen] = useState(false); // State to manage the mobile nav menu
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');


    
    
    

    const [address, setAddress] = useState({
        organization: '',
        addressline1: '',
        addressline2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        latitude: '',
        longitude: '',
        place_id: '',
        photo_url: '',
    });

    

    const ethnicityOptions = [
        'African/African American/Black',
        'Arab/Middle Eastern',
        'Asian/Asian American',
        'Caucasian/White',
        'Hispanic/Latino/Latina/Latinx',
        'Indigenous/Native American/Alaska Native',
        'Native Hawaiian/Pacific Islander',
        'Mixed/Multiple ethnicities',
        'Other',
        'Prefer not to say'
      ];
      const genderOptions = [
        'Woman',
        'Man',
        'Non-binary',
        'Transgender woman',
        'Transgender man',
        'Genderqueer',
        'Genderfluid',
        'Agender',
        'Other',
        'Prefer not to say'
      ];
      const religionOptions = [
        'Agnosticism',
        'Atheism',
        'Baha\'i Faith',
        'Buddhism',
        'Christianity',
        'Hinduism',
        'Islam',
        'Jainism',
        'Judaism',
        'Paganism',
        'Secular Humanism',
        'Shinto',
        'Sikhism',
        'Spiritual but not religious',
        'Taoism',
        'Traditional Indigenous/Native Faith',
        'Unitarian Universalism',
        'Zoroastrianism',
        'Other',
        'Prefer not to say'
      ];
      
      const sexualOrientationOptions = [
        'Heterosexual/Straight',
        'Gay',
        'Lesbian',
        'Bisexual',
        'Pansexual',
        'Asexual',
        'Demisexual',
        'Queer',
        'Questioning',
        'Fluid',
        'Omnisexual',
        'Graysexual',
        'Aromantic',
        'Other',
        'Prefer not to say'
      ];
      
      const neurologicalDisabilityOptions = [
        'Epilepsy',
        'Multiple sclerosis',
        'Parkinson\'s disease',
        'Cerebral palsy',
        'Traumatic brain injury',
        'Stroke-related disability',
        'Migraine disorder',
        'Spinal cord injury',
        'Huntington\'s disease',
        'Other neurological disability',
        'Prefer not to say'
      ];
      
      const intellectualDisabilityOptions = [
        'Down syndrome',
        'Fragile X syndrome',
        'Developmental delay',
        'Fetal alcohol spectrum disorder',
        'Intellectual disability - mild',
        'Intellectual disability - moderate',
        'Intellectual disability - severe',
        'Other intellectual disability',
        'Prefer not to say'
      ];
      
      const mentalHealthConditionOptions = [
        'Anxiety disorder',
        'Depression',
        'Bipolar disorder',
        'Post-traumatic stress disorder (PTSD)',
        'Obsessive-compulsive disorder (OCD)',
        'Schizophrenia',
        'Eating disorder',
        'Personality disorder',
        'Substance use disorder',
        'Other mental health condition',
        'Prefer not to say'
      ];
      
      const physicalDisabilityOptions = [
        'Muscular dystrophy',
        'Spina bifida',
        'Amputation',
        'Arthritis',
        'Chronic pain',
        'Cystic fibrosis',
        'Fibromyalgia',
        'Limited mobility',
        'Wheelchair user',
        'Dwarfism/short stature',
        'Other physical disability',
        'Prefer not to say'
      ];
      const sensoryDisabilityOptions = [
        'Blindness',
        'Low vision',
        'Color blindness',
        'Deaf',
        'Hard of hearing',
        'Deaf-Blind',
        'Auditory processing disorder',
        'Visual processing disorder',
        'Other sensory disability',
        'Prefer not to say'
      ];

     useEffect(() => {
            const token = Cookies.get("accessToken");
            const username = Cookies.get("username");
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
                    const currentTime = Date.now();
                    const timeUntilExpiration = expirationTime - currentTime;
    
                    if (timeUntilExpiration > 0) {
                        // Redirect to auth page when token expires
                        setTimeout(() => {
                            Cookies.remove("accessToken");
                            navigate("/auth");
                        }, timeUntilExpiration);
                        setIsLoggedIn(true);
                        setUsername(username);
                    } else {
                        navigate("/auth");
                    }
                } catch (error) {
                    console.error("Invalid token:", error);
                    Cookies.remove("accessToken");
                    navigate("/auth");
                }
            }
        }, [navigate, username]);
        
         const loadOptions = async (inputValue, callback) => {
            if (!inputValue.trim()) {
                callback([]);
                return;
            }
    
            try {
                const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/incidents/typeAhead?query=${inputValue}`);
                const data = await response.json();
    
                if (Array.isArray(data)) {
                    callback(
                        data.slice(0, 5).map((item) => ({
                            value: item.id,
                            label: `${item.organization} - ${item.city}, ${item.state}, ${item.country}`
                        }))
                    );
                } else {
                    callback([]);
                }
            } catch (error) {
                console.error("Error fetching suggestions:", error);
                callback([]);
            }
        };
    
        
        const handleChange = (event, { newValue }) => {
            setQuery(newValue || ''); // Ensure it's always a string
        };
         const checkAuthAndRedirect = (callback) => {
                const token = Cookies.get("accessToken");
                if (!token) {
                    navigate("/auth"); // Redirect to auth if no token
                } else {
                    callback(); // Execute the button's original action
                }
            };
        
            const checkAuthAndNavigate = (path) => {
                const token = Cookies.get("accessToken");
                if (!token) {
                    navigate("/auth"); // Redirect to auth if no token
                } else {
                    navigate(path); // Navigate to the intended path
                }
            };
    
    const fetchPlaceDetails = async (placeId) => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/place-name?place_id=${placeId}`);
            const data = await response.json();

            if (data.name) {
                return data.name; // Business Name
            } else {
                console.error("No name found in response", data);
                return "";
            }
        } catch (error) {
            console.error("Failed to fetch place details:", error);
            return "";
        }
    };

    const fetchPlacePhotos = async (placeId) => {
         try {
                const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/place-photos/${placeId}`, {
                    headers: {
                         'X-Goog-Api-Key': 'AIzaSyAEOau3wDYC1x163cItZYvpCsW-4bknKzc', 
                        'X-Goog-FieldMask': 'photos.name'
                    }   
                });
                if (!response.ok) {
                    console.error("❌ Error fetching place photos:", response.statusText);
                    return null;
                }
                // Check if the response contains photos
                const photoBlob = await response.blob();
        
                return photoBlob;

                
        
        
            } catch (error) {
                console.error("❌ Error fetching place details:", error.message);
                
            }
    };

    const placeDetailsMapRef = useRef(new Map());

    const handleAutocomplete = async (place) => {
        if (!place || !place.place_id) {
            console.error("Invalid place selected");
            return;
        }
          // ✅ Store place_id in `useRef`
    placeIdRef.current = place.place_id;

        console.log("Full Place Object:", JSON.stringify(place, null, 2)); // Debugging

        let organizationName = place.name || '';

        const addressComponents = place.address_components.reduce((acc, component) => {
            const type = component.types[0];
            if (type === "street_number") acc.addressline1 = component.long_name;
            if (type === "route") acc.addressline1 += ` ${component.long_name}`;
            if (type === "locality") acc.city = component.long_name;
            if (type === "administrative_area_level_1") acc.state = component.short_name;
            if (type === "postal_code") acc.zip = component.long_name;
            if (type === "country") acc.country = component.long_name;
            return acc;
        }, {});

        if (!organizationName && place.place_id) {
            const businessName = await fetchPlaceDetails(place.place_id);
            organizationName = businessName || '';
        }

        setAddress({
            organization: organizationName,
            ...addressComponents,
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            place_id: place.place_id || '',
        });

        console.log("Updated Address:", {
            organization: organizationName,
            ...addressComponents,
            place_id: place.place_id || '',
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
        });
        const photoBlob = await fetchPlacePhotos(place.place_id);
        if (photoBlob) {
            setPhotoBlob(photoBlob);


        // ✅ Directly update useRef (synchronous)
        placeDetailsMapRef.current.set(place.place_id, { photoBlob });

        console.log("📍 Synchronous PlaceDetailsMap:", placeDetailsMapRef.current);

        // ✅ Still update state (optional, but not needed for immediate access)
        setPlaceDetailsMap(new Map(placeDetailsMapRef.current));
        }

    
        
    };

    const { ref } = usePlacesWidget({
        apiKey: 'AIzaSyAEOau3wDYC1x163cItZYvpCsW-4bknKzc',
        onPlaceSelected: handleAutocomplete,
        options: {
            types: ['geocode', 'establishment'],
            componentRestrictions: { country: 'us' },
        },
    });

    const uploadToS3 = async (file, incidentId) => {
        try {
            // ✅ Step 1: Prepare FormData for file upload
            const formData = new FormData();
            formData.append("incidentId", incidentId);
            formData.append("file", file);
    
            // ✅ Step 2: Send file to backend route
            const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/upload-to-s3`, {
                method: "POST",
                body: formData, // 🔹 Send FormData (no need for headers, browser sets it automatically)
            });
    
            if (!response.ok) {
                throw new Error("Failed to upload file to S3");
            }
    
            // ✅ Step 3: Get uploaded file URL from backend response
            const { url } = await response.json();
            console.log("✅ File successfully uploaded to S3:", url);
    
            return url; // Return clean file URL
        } catch (error) {
            console.error("❌ Upload error:", error);
            throw error;
        }
    };
    const handlePlaceValidation = async (placeId) => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/place-types/${placeId}`, {
                method: "GET",
                headers: {
                    'X-Goog-Api-Key': 'AIzaSyAEOau3wDYC1x163cItZYvpCsW-4bknKzc', 
                   'X-Goog-FieldMask': 'types'
               } 
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Failed to validate place.");
            }
    
            const data = await response.json();
            console.log("Place types validated successfully:", data.types);
            return true; // Validation passed
        } catch (error) {
            console.error("Error:", error.message);
            setErrorMessage(error.message); // Display the error in the UI
            setOpenSnackbar(true); // Show the error in a Snackbar or other UI component
            return false; // Validation failed
        }
    };
    
    
    

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validate if place_id is present
   
    // Validate if race is required for racial incidents
    if (incident_type === 'Racist' && myIncident===false && !race) {
        setErrorMessage('Race is required for racial incidents.');
        setSuccessMessage('');
        setOpenSnackbar(true); // Show error message in Snackbar
        return; // Stop further execution
    }
    // Validate if race is required for racial incidents
    if ((incident_type === 'Homophobic' || incident_type === 'Transphobic') && myIncident===false && (!gender)) {
        setErrorMessage('Gender is required for Homophobic & Transphobic incidents.');
        setSuccessMessage('');
        setOpenSnackbar(true); // Show error message in Snackbar
        return; // Stop further execution
    }

    if ((incident_type === 'Homophobic' || incident_type === 'Transphobic') && myIncident===false && (!sexual_orientation)) {
        setErrorMessage('Sexual Orientation is required for Homophobic & Transphobic incidents.');
        setSuccessMessage('');
        setOpenSnackbar(true); // Show error message in Snackbar
        return; // Stop further execution
    }
    if (!incident_type) {
        setErrorMessage('Incident Type is required.');
        setSuccessMessage('');
        setOpenSnackbar(true); // Show error message in Snackbar
        return; // Stop further execution
    }
    if (!description) {
        setErrorMessage('You must enter a summary of the incident.');
        setSuccessMessage('');
        setOpenSnackbar(true); // Show error message in Snackbar
        return; // Stop further execution
    }

    // Add this before form submission
if (incident_type === 'Ableist' && myIncident === false) {
    if (!disability_type) {
        setErrorMessage('Disability category is required for ableist incidents');
        setOpenSnackbar(true);
        return;
    }
    if (!disability) {
        setErrorMessage('Specific disability type is required');
        setOpenSnackbar(true);
        return;
    }
}



   const selectedPlaceId = placeIdRef.current;
    console.log("📍 Retrieved Place ID:", selectedPlaceId);

    // 🔴 Ensure `place_id` exists
    if (!selectedPlaceId) {
        console.error("❌ No place_id available");
        return;
    }

    // ✅ Retrieve from `useRef`
    const placeDetails = placeDetailsMapRef.current.get(selectedPlaceId);

    console.log("📍 Retrieved Place Details:", placeDetails);

     // Validate place types before proceeding
     const isValidPlace = await handlePlaceValidation(selectedPlaceId);
     if (!isValidPlace) {
         return; // Stop form submission if validation fails
     }
        let uploadedPhotoUrl = '';

        // ✅ Upload `photoBlob` if it exists
        if (placeDetails && placeDetails.photoBlob) {
            try {
                const incidentId = `place_photo_${selectedPlaceId}`;
                uploadedPhotoUrl = await uploadToS3(placeDetails.photoBlob, incidentId);
                console.log("Uploaded photo URL:", uploadedPhotoUrl);
            } catch (error) {
                console.error("❌ Error uploading place photo:", error);
            }
        } else {
            console.warn("⚠️ No photoBlob found for place_id:", place_id);
        }
         // Step 1: Get the username from cookies
         const username = Cookies.get("username");
         if (!username) {
             setErrorMessage("Username not found. Please log in again.");
             setOpenSnackbar(true);
             return;
         }
 
         // Step 2: Fetch the user ID from the API
         const userResponse = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/auth/user/${username}`);
         if (!userResponse.ok) {
             setErrorMessage("Failed to fetch user details. Please try again.");
             setOpenSnackbar(true);
             return;
         }
         const userData = await userResponse.json();
         const userId = userData.id;
 
        const constructedPhotoUrl = `https://my-image-bucket-the-green-book.s3.us-east-1.amazonaws.com/incident_photos/place_photo_${selectedPlaceId}.jpg`

        const payload = {
            race,
            incident_type,
            additional_info,
            description,
            date_time,
            place_id,
            disability_type,
            disability,
            photo_url: constructedPhotoUrl,
            sexual_orientation,
            user_id: userId, // Add user ID to the payload
            username,
            myIncident: Boolean(myIncident), // Explicit boolean conversion
            ...address
        };
         // Validate if `place_id` is present in the payload
    if (!payload.organization) {
        setErrorMessage('Place ID is missing from the request payload. Please select a valid organization or address.');
        setSuccessMessage('');
        setOpenSnackbar(true); // Show error message in Snackbar
        return; // Stop further execution
    }

        console.log('Incident Data:', payload);

        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/incidents`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
    
            if (response.status === 201) {
                const newIncident = await response.json();
                setSuccessMessage('Incident submitted successfully!');
                setErrorMessage('');
                setOpenSnackbar(true);
                
                // First trigger the success state
                onIncidentSubmit(newIncident); 
                
                // Then delay the redirect to allow the message to show
                setTimeout(() => {
                    if (typeof onIncidentSubmit === 'function') {
                        onIncidentSubmit(newIncident); // Call the callback first
                    }
                    
                    // Safely close the modal
                    if (typeof setModalIsOpen === 'function') {
                        setModalIsOpen(false);
                    } else {
                        console.warn('setModalIsOpen is not a function');
                    }
                    
                    navigate('/incidents');
                }, 3000);
            } else {
                const errorData = await response.json();
                setErrorMessage(errorData.message || 'Failed to submit the incident.');
                setSuccessMessage('');
                setOpenSnackbar(true); // ✅ Open Snackbar on error
            }
        } catch (error) {
            console.error('Error submitting incident:', error);
            setErrorMessage('Failed to submit the incident.');
            setSuccessMessage('');
            setOpenSnackbar(true); // ✅ Open Snackbar on error
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen">
           
       
        <Box
        
            sx={{
            width: '100%',
            maxWidth: '600px',
            backgroundColor: 'white',
            padding: 4,
            borderRadius: 3,
            boxShadow: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            overflowY: 'auto',
            margin: 'auto', // Centers horizontally
            position: 'absolute', // Allows vertical centering
            top: '50%', 
            left: '50%',
            transform: 'translate(-50%, -50%)', // Adjusts positioning for true centering
            '@media (max-width: 768px)': {
                maxWidth: '90%',
                padding: 2,
            },
            }}
        >
            {/* Snackbar for success or error messages */}
           
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                TransitionComponent={Slide} // ✅ Explicit transition
            >
                <Alert 
                    onClose={() => setOpenSnackbar(false)} 
                    severity={successMessage ? "success" : "error"}
                >
                    {successMessage || errorMessage}
                </Alert>
            </Snackbar>
            
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                Report an Incident
            </Typography>
                
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '8px' }}>
                    <input
                        ref={ref}
                        placeholder="Enter Organization or Address"
                        style={{
                            width: '100%',
                            padding: '8px',
                            fontSize: '16px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                    />
                </div>

                {Object.keys(address)
                    .filter((field) => field !== 'latitude' && field !== 'longitude' && field !== 'place_id' && field !== 'addressline1' && field !== 'addressline2' && field !== 'organization' && field !== 'zip' && field !== 'country' && field !== 'state' && field !== 'city' && field !== 'photo_url')
                    .map((field, idx) => (
                        <TextField sx={{ mb: 2 }}
                            key={idx}
                            label={field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            name={field}
                            value={address[field]}
                            fullWidth
                            margin="normal"
                            disabled
                        />
                    ))}

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Incident Type</InputLabel>
                    <Select value={incident_type} onChange={(e) => setIncidentType(e.target.value)}>
                        <MenuItem value="Racist">Racist</MenuItem>
                        <MenuItem value="Islamaphobic">Islamaphobic</MenuItem>
                        <MenuItem value="Antisemitic">Antisemitic</MenuItem>
                        <MenuItem value="Ableist">Ableist</MenuItem>
                        <MenuItem value="Homophobic">Homophobic</MenuItem>
                        <MenuItem value="Transphobic">Transphobic</MenuItem>
                        
                        <MenuItem value="other">Other</MenuItem>
                    </Select>
                </FormControl>
                {incident_type &&(
                     <Paper elevation={0} sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                     <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
                         Who are you submitting this report for?
                     </Typography>
                     <RadioGroup
                        value={myIncident} // Direct boolean value
                        onChange={(e) => setMyIncident(e.target.value === "true")}
                        row
                    >
                        <FormControlLabel 
                            value={true} // Actual boolean true
                            control={<Radio />}
                            label="I am reporting an incident that happened to me" 
                        />
                        <FormControlLabel 
                            value={false} // Actual boolean false
                            control={<Radio />}
                            label="I am reporting on behalf of someone else" 
                        />
                    </RadioGroup>
                 </Paper>
                )}

                {incident_type === 'Racist' && myIncident === false&& (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Race</InputLabel>
                        <Select value={race} onChange={(e) => setRace(e.target.value)}>
                            <MenuItem value="Black">Black</MenuItem>
                            <MenuItem value="American Indian or Alaska Native">
                                American Indian or Alaska Native
                            </MenuItem>
                            <MenuItem value="South East Asian">South East Asian</MenuItem>
                            <MenuItem value="Native Hawaiian or Pacific Islande">
                                Native Hawaiian or Pacific Islander
                            </MenuItem>
                            <MenuItem value="Latino">Latino</MenuItem>
                            <MenuItem value="Middle Eastern">Middle Eastern</MenuItem>
                            <MenuItem value="Jewish">Jewish</MenuItem>
                        </Select>
                    </FormControl>
                )}
                {incident_type === 'Islamaphobic' && myIncident === false&& (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>What is your ethicity</InputLabel>
                    <Select
                    value={race}
                    label="Sensory Disability Type"
                    onChange={(e) => setRace(e.target.value)}
                    >
                    {ethnicityOptions.map((option) => (
                        <MenuItem 
                        key={option} 
                        value={option}
                        sx={{
                            whiteSpace: 'normal',
                            py: 1.5
                        }}
                        >
                        {option}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>
                )}

                {(incident_type === 'Homophobic' || incident_type === 'Transphobic') && myIncident === false && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Gender</InputLabel>
                        <Select value={gender} onChange={(e) => setGender(e.target.value)}>
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Non-binary">Non-binary</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                    </FormControl>
                )}

                {(incident_type === 'Homophobic' || incident_type === 'Transphobic') && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Sexual Orientation</InputLabel>
                        <Select value={sexual_orientation} onChange={(e) => setSexualOrientation(e.target.value)}>
                            <MenuItem value="Heterosexual">Heterosexual</MenuItem>
                            <MenuItem value="Homosexual">Homosexual</MenuItem>
                            <MenuItem value="Bisexual">Bisexual</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                    </FormControl>
                )}
                {sexual_orientation === 'Other' && (
                    <TextField
                        label="Specify Sexual Orientation"
                        value={additional_info}
                        onChange={(e) => setAdditionalInfo(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                )}
                 {incident_type === 'Ableist' && myIncident === false &&(

                     <>

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Disability Type</InputLabel>
                        <Select
                        value={disability_type} onChange={(e) => setDisabilityType(e.target.value)} >
                        <MenuItem value="Sensory">Sensory disability</MenuItem>
                        <MenuItem value="Neurological">Neurological disability</MenuItem>
                        <MenuItem value="Intellectual">Intellectual disability</MenuItem>
                        <MenuItem value="Mental-Health">Mental health condition</MenuItem>
                        <MenuItem value="Physical">Physical disability</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                        </Select>
                    </FormControl>
                    


            {/* Show specific sensory options if user selected "sensory" */}
                    {disability_type === "Sensory" && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Sensory Disability Type</InputLabel>
                        <Select
                        value={disability}
                        label="Sensory Disability Type"
                        onChange={(e) => setDisability(e.target.value)}
                        >
                        {sensoryDisabilityOptions.map((option) => (
                            <MenuItem 
                            key={option} 
                            value={option}
                            sx={{
                                whiteSpace: 'normal',
                                py: 1.5
                            }}
                            >
                            {option}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    )}

                    {/* Similar pattern for other disability categories */}
                    {disability_type === "Neurological" && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Neurological Disability Type</InputLabel>
                        <Select
                        value={disability}
                        label="Neurological Disability Type"
                        onChange={(e) => setDisability(e.target.value)}
                        >
                        {neurologicalDisabilityOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    )}

                    {/* Repeat for other disability categories */}

                    {disability_type === "Physical" && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Physical Disability Type</InputLabel>
                        <Select
                        value={disability}
                        label="Physical Disability Type"
                        onChange={(e) => setDisability(e.target.value)}
                        >
                        {physicalDisabilityOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    )}

                    {disability_type === "Mental-Health" && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Mental Health Condition Type</InputLabel>
                        <Select
                        value={disability}
                        label="Mental Health Condition Type"
                        onChange={(e) => setDisability(e.target.value)}
                        >
                        {mentalHealthConditionOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    )}

                    {disability_type === "Intellectual" && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Intellectual Disability Type</InputLabel>
                        <Select
                        value={disability}
                        label="Intellectual Disability Type"
                        onChange={(e) => setDisability(e.target.value)}
                        >
                        {intellectualDisabilityOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    )}
                 </>
                )}
                

                

                <TextField
                    label="Summarize Your Experience"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    fullWidth
                    margin="normal"
                    multiline
                    rows={4}
                />

                <TextField
                    label="Date and Time"
                    type="datetime-local"
                    value={date_time}
                    onChange={(e) => setIncidentDateTime(e.target.value)}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    sx={{ display: 'none' }} // Hide the input field
                />
                

                <Button 
                type="submit" 
                variant="contained" 
                className="button"
                fullWidth 
                sx={{
                    backgroundColor: '#276749',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '10px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    width: '100%',
                    '&:hover': {
                      backgroundColor: '#004d00', // Darker green on hover
                    },
                  }}>
                    Submit
                </Button>
            </form>

            
        </Box>
        </div>
    );
};

export default ReportIncidentForm;